<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm03">
<a id="pagexv">
<div class="chapterHead">
<h2 class="chapterTitle"><em class="italic">Can you imagine an astral plane somewhere “out there”</em></h2></div>
</a><div class="chapterBody"><a id="pagexv">
<p class="paraCenter"><em class="italic">where very old souls could rendezvous to practice and perfect their most highly developed manifestation techniques? A members-only kind of place, where whatever they think about comes to life in the most vivid high-definition, surround sound Technicolor, vis-à-vis the most intricate plots and circumstances? Where the only limits that exist lie in their ability to imagine what they have never before imagined, and to move with it in anticipation of its “physical” expression?</em></p>
<p class="spaceBreak1"> </p>
<p class="paraCenter"><em class="italic">And best of all, being astral, no harm can come to them. They’re completely untouchable. Nothing is real, yet everything matters. And there can be infinite gains in terms of insight and fun, yet no losses since everything is illusory. Actually, the worst thing that can happen is that they temporarily become so entranced by their creations, they completely forget who they are, where they are, and how powerful they really are.</em></p>
<p class="spaceBreak1"> </p>
<p class="paraCenter"><em class="italic">Yep, it would be exactly like this astral plane. Only here, to help wake ’em up from their trance, we’re experimenting with Notes from the Universe…</em></p>
</a><a id="pagexvi">
</a></div><a id="pagexvi">
</a></div><a id="pagexvi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416594161_fm03.vue?6d1691e5